import { Badge } from "@/components/ui/badge";

const STYLES = {
  requested: "bg-[#D99A5A]/15 text-[#A86A22]",
  quoted: "bg-[#E2DBD6] text-[#2A2624]",
  scheduled: "bg-[#2A2624]/10 text-[#2A2624]",
  in_progress: "bg-[#C77F8C]/15 text-[#A35C6A]",
  completed: "bg-[#2A2624]/15 text-[#2A2624]",
  cancelled: "bg-[#B04A4A]/15 text-[#B04A4A]",
};

export default function StatusBadge({ status }) {
  const cls = STYLES[status] || "bg-gray-100 text-gray-700";
  return (
    <Badge data-testid={`status-${status}`} className={`rounded-full capitalize ${cls} hover:${cls}`}>
      {status.replace("_", " ")}
    </Badge>
  );
}
